import axiosInstance from "@/api/axios-instance";

export interface Note {
  id: string;
  content: string;
  session_id: string | null;
  user_id: string | null;
  created_at: string;
  updated_at: string;
  created_by: string | null;
}

export async function getUserNotes(userId: string): Promise<Note[]> {
  const response = await axiosInstance.get(`/note/user/${userId}`);

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to fetch user notes");
  }

  return response.data;
}

